module.exports = "/assets/b8587bdfd55cd8181e079037d9882b75.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/KQ.png
// module id = 1554
// module chunks = 0